import React from 'react';
import rollbar from '../services/intake/rollbar';

const buttonLinkStyle = {
  background: 'none',
  border: 'none',
  textDecoration: 'underline',
  fontSize: '1em',
  color: 'LinkText',
  cursor: 'pointer'
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI

    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can use your own error logging service here
    console.log({ error, errorInfo });
    rollbar.error(error, errorInfo);
  }

  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ padding: '1em' }}>
          <h2 style={{ marginBottom: '0.5em' }}>An unexpected error occurred</h2>
          <p style={{ marginTop: '0.5em' }}>
            <code>{this.state.error.message}</code>
          </p>
          <br />
          <p>
            Support has been notified. {' '}
            <button
              type="button"
              onClick={() => this.setState({ hasError: false })}
              style={buttonLinkStyle}
            >
              Try again?
            </button>
          </p>
        </div>
      );
    }

    // Return children components in case of no error

    return this.props.children;
  }
}

export default ErrorBoundary;
